<template>
  <div class="taxi-voucher-wrapper">
    <Title v-if="title && title.TaxiService" :title-name="pageTitle" :title-link="title.TaxiService.titleLink" />
    <div v-if="canShowTaxiVoucher" class="taxi-voucher-container container">
      <ItemOfVouchers
        icon="taxi-voucher"
        color="#56c3e0"
        :label="lang && lang['taxi'] ? lang['taxi'].SFS_LANG_ROW_1 : ''"
        border
      />
      <OptionTaxi
        v-if="stateTaxiService == states.TAXI_OPTION"
        :secret="secret"
        :index-booking="indexBooking"
        :overnight-station="OverNightStation"
        @updateState="updateState"
      ></OptionTaxi>
      <TaxiPhotoPay
        v-if="stateTaxiService == states.TAXI_PHOTO2CLAIM"
        :voucher="Voucher"
        :index-booking="indexBooking"
        :secret="secret"
      />
    </div>
    <div v-else>
      <div v-if="lang['taxi']" class="container">
        <div style="margin: 14pt 0">{{ lang['taxi'].SFS_LANG_TAXI_VOUCHER_ALREADY_PROVIDED }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import Title from '@/components/Title/index'
import ItemOfVouchers from '@/components/ItemOfVouchers'
import OptionTaxi from './components/OptionTaxi'
import TaxiPhotoPay from './components/TaxiPhotoPay'
import { mapGetters } from 'vuex'

export default {
  name: 'TaxiService',
  components: {
    Title,
    ItemOfVouchers,
    OptionTaxi,
    TaxiPhotoPay
  },
  props: {
    secret: {
      type: String,
      default: ''
    },
    indexBooking: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      curPaxId: null,
      matrixShareTaxi: [],
      states: {
        TAXI_OPTION: 1,
        TAXI_PHOTO2CLAIM: 3
      },
      stateTaxiService: 0,
      taxiService: {}
    }
  },
  computed: {
    ...mapGetters({
      Services: 'Home/Services',
      PaxsHotel: 'SelectRoom/PaxsHotel',
      Voucher: 'Taxi/Voucher',
      OverNightStation: 'Home/OverNightStation'
    }),
    pageTitle() {
      const { lang } = this
      return lang && lang.hotel_mobile_new && this.lang.hotel_mobile_new.SFS_LANG_ROW_28
        ? lang.hotel_mobile_new.SFS_LANG_ROW_28
        : 'Home'
    },
    canShowTaxiVoucher() {
      return this.airline && (this.airline.show_taxi_voucher || this.stateTaxiService === this.states.TAXI_PHOTO2CLAIM)
    }
  },
  watch: {
    airline: function () {
      this.stateTaxiService = this.initData()
    }
  },
  beforeMount() {
    this.initData()
  },
  methods: {
    async initData() {
      this.stateTaxiService = 0
      this.curPaxId = this.pax.id || this.pax.curPaxId
      if (!_.isEmpty(this.airline)) {
        await Promise.all([
          this.$store.dispatch('Home/getServices'),
          this.$store.dispatch('SelectRoom/getPaxsHotel'),
          this.$store.dispatch('Taxi/getTaxiVoucher'),
          this.$store.dispatch('getAirline'),
          this.$store.dispatch('Home/getOverNightStation')
        ])
        this.taxiService = _.find(this.Services, function (service) {
          return service.service_id == 4
        })
        this.checkMatrixShareTaxi()
        this.stateTaxiService = this.getStateTaxiService()
      }
    },
    checkMatrixShareTaxi() {
      if (_.isUndefined(this.taxiService) && _.isEmpty(this.taxiService)) {
        return
      }
      let matrixShareTaxi =
        !_.isUndefined(this.taxiService.params) &&
        !_.isEmpty(this.taxiService.params) &&
        !_.isUndefined(this.taxiService.params.matrix_share_taxi) &&
        this.taxiService.params.matrix_share_taxi
          ? [...this.taxiService.params.matrix_share_taxi]
          : []
      this.matrixShareTaxi = matrixShareTaxi
    },
    getStateTaxiService() {
      let self = this
      let state = 0
      if (!_.isEmpty(self.airline)) {
        // Check the voucher has been used
        let curVoucher = self.checkCurVoucher()
        if (!_.isEmpty(curVoucher) && curVoucher.used_transfer_wise) {
          //used Photo2Claim
          return self.states.TAXI_PHOTO2CLAIM
        }
        let hasShortCodeOrUsedTransferWise = self.hasShortCodeOrUsedTransferWise()
        state = self.states.TAXI_OPTION
        if (
          (!_.isEmpty(self.Voucher) && !self.isMatrixRequired()) ||
          (hasShortCodeOrUsedTransferWise && !self.isMatrixRequired())
        ) {
          let taxiConfig = self.airline.taxi_config.mobile_self_service || ''
          switch (taxiConfig) {
            case 'taxi2ride':
              if (self.isTaxi2RideReject() || self.isPrintedP2C()) {
                state = self.states.TAXI_PHOTO2CLAIM
              }
              break
            case 'photo2claim':
              state = self.states.TAXI_PHOTO2CLAIM // go to add receipt screen
              break
            case 'none':
              if (self.airline.taxi_config.print_a4 === 'photo2claim') {
                state = self.states.TAXI_PHOTO2CLAIM
              }
              break
            default:
              break
          }
        }
      }

      return state
    },
    isMatrixRequired() {
      return _.isEmpty(this.matrixShareTaxi) && this.PaxsGroup.length > 1 && !this.payedTransferWise()
    },
    payedTransferWise() {
      let self = this
      return _.some(self.Voucher, function (voucher) {
        return voucher.used_transfer_wise === 1
      })
    },
    checkCurVoucher() {
      let self = this
      if (!self.matrixShareTaxi.length || !self.Voucher || _.isUndefined(self.curPaxId)) {
        return null
      }
      let paxGroup = _.find(self.matrixShareTaxi, function (group) {
        return _.indexOf(group, self.curPaxId.toString()) >= 0
      })
      let paxVoucher = Object.keys(self.Voucher)
      let indexVoucher = _.find(paxVoucher, function (paxId) {
        return _.indexOf(paxGroup, paxId.toString()) >= 0
      })

      let voucher = self.Voucher[indexVoucher]
      return voucher
    },
    hasShortCodeOrUsedTransferWise() {
      if (_.isEmpty(this.Voucher)) {
        return false
      }
      return _.some(this.Voucher, function (voucher) {
        let detail =
          !_.isUndefined(voucher.details) && voucher.details && !_.isUndefined(voucher.details[0]) && voucher.details[0]
            ? voucher.details[0]
            : null
        let usedTransferWise = !_.isUndefined(voucher.used_transfer_wise) ? voucher.used_transfer_wise : 0
        let hasShortCode = !_.isUndefined(detail.set_short_code) && detail.set_short_code
        return hasShortCode || usedTransferWise === 1
      })
    },
    isPrintedP2C() {
      if (
        !_.isEmpty(this.taxiService) &&
        !_.isEmpty(this.airline.taxi_config.print_a4) &&
        this.taxiService.count_print > 0 &&
        this.airline.taxi_config.print_a4 == 'photo2claim'
      ) {
        return true
      }
      return false
    },
    isTaxi2RideReject() {
      let isReject = false
      if (!_.isEmpty(this.taxiService) && !_.isEmpty(this.taxiService.params)) {
        let attempt = this.taxiService.params.times_attempts_to_connect_karhoo || 0
        let isAbort = this.taxiService.params.is_abort || 0
        if (parseInt(attempt) === parseInt(this.airline.times_attempts_to_connect_karhoo) || isAbort) {
          isReject = true
        }
      }
      return isReject
    },

    async updateState() {
      await this.initData()
    }
  }
}
</script>
<style lang="scss" scoped>
.taxi-voucher-wrapper {
  background-color: #f4f4f4;
  .taxi-voucher-container {
    background-color: #f4f4f4;
    padding: 1rem 1.5rem;
  }
}
</style>
